/**
 * Sets how many results enable searching
 * in the student scope filter?
 */
export const searchThreshold = 8;

// supported filter names
export const FILTER_SCHOOLS = 'schools';
export const FILTER_SCHOOLS_9_THROUGH_12 = 'schools_9_through_12';
export const FILTER_CASELOADS = 'caseloads';
export const FILTER_CASELOADS_9_THROUGH_12 = 'caseloads_9_through_12';
export const FILTER_GRADES = 'grades';
export const FILTER_GRADES_K12_ONLY = 'grades_k12_only';
export const FILTER_GRADES_9_THROUGH_12_ONLY = 'grades_9_through_12_only';
export const FILTER_GRADES_6_THROUGH_11_ONLY = 'grades_6_through_11_only';
export const FILTER_GRADES_6_THROUGH_12_ONLY = 'grades_6_through_12_only';
export const FILTER_GRADES_K_THROUGH_5_ONLY = 'grades_K_through_5_only';
export const FILTER_GRADES_ELEMENTARY_AND_SECONDARY =
  'grades_elementary_and_secondary';
export const FILTER_K12_SCHOOL_TAGS = 'k12_school_tags';
// BAD: temporary solution for different query param keys used for student tags
export const FILTER_STUDENT_TAGS = 'tags';
export const FILTER_STUDENT_TAGS_9_THROUGH_12 = 'tags_9_through_12';
export const FILTER_STUDENT_TAGS_VERBOSE = 'studentTag';
export const FILTER_STUDENT_TAGS_OFFICIAL = 'officialTags';
export const FILTER_STUDENT_TAGS_PERSONAL = 'personalTags';
export const FILTER_ACTIVITIES = 'activities';
export const FILTER_CLASSYEAR = 'classYear';
export const FILTER_CLASS_YEARS = 'classYears';
export const FILTER_ALUMNI_CLASS_YEARS = 'alumniClassYears';
export const FILTER_ALPHALASTNAME = 'alphaLastName';
export const FILTER_CASELOAD_SOURCE = 'caseloadSource';
export const FILTER_CASELOAD_TYPE = 'caseloadType';
export const FILTER_STUDENT_TAG_SOURCE = 'studentTagSource';
export const FILTER_STUDENT_TAG_TYPE = 'studentTagType';
export const FILTER_BULK_IDENTIFIER_MATCH = 'bulkMatch';
export const FILTER_RESTRICTED_SCHOOLS = 'restrictedSchools';
export const FILTER_RESTRICTED_SCHOOLS_ELEMENTARY_AND_SECONDARY =
  'restrictedSchoolsElementaryAndSecondary';
